import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SrdUser } from '../models/srd-user';
import { DialogOverviewExampleDialog } from '../shared/dialog-overview/dailog-overview-example-dialog.component';
import { forbiddenValidator } from '../shared/forbidden.validator';
import { RegistrationService } from './register.service';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
})
export class RegistrationComponent implements OnInit {
  router: Router;
  user: SrdUser;
  registrationForm: FormGroup;
  message:string = '';
  dialog: boolean = false;

  constructor(
    private fb: FormBuilder,
    router: Router,
    private registrationService: RegistrationService
  ) {
    this.router = router;
  }

  ngOnInit(): void {
    this.registrationForm = this.fb.group({
      contactPerson: [, { validators: [Validators.required] }],
      clientOrganization: [, { validators: [Validators.required] }],
      branch: [, { validators: [Validators.required] }],

      userEmail: [
        ,
        {
          validators: [Validators.required, Validators.email],
          updateOn: 'change',
        },
      ],
      userPassword: [
        ,
        [Validators.required, Validators.minLength(8), forbiddenValidator()],
      ],
      gender: [, { validators: [Validators.required] }],
    });
  }

   


  getEmailErrorMessage() {
    return this.userEmail.hasError('required')
      ? 'You must enter a value'
      : this.userEmail.hasError('email')
      ? 'Email should be of form johndoe@example.com'
      : this.userEmail.hasError('userExists')
      ? 'User already exists!'
      : '';
  }

  getPasswordErrorMessage() {
    return this.userPassword.hasError('required')
      ? 'You must enter a value'
      : this.userPassword.hasError('passwordStrength')
      ? 'Your password must have lower case, upper case, numeric characters with min 8 characters including atleast one of ?#_%.@ '
      : '';
  }

  get userEmail() {
    return this.registrationForm.get('userEmail');
  }
  get userPassword() {
    return this.registrationForm.get('userPassword');
  }
  get contactPerson() {
    return this.registrationForm.get('contactPerson');
  }
  get clientOrganization() {
    return this.registrationForm.get('clientOrganization');
  }
  get branch() {
    return this.registrationForm.get('branch');
  }

  get gender() {
    return this.registrationForm.get('gender');
  }

  register() {
    var user = new SrdUser();
    user.contactPerson = this.contactPerson.value;
    user.clientOrganization = this.clientOrganization.value;
    user.branch = this.branch.value;
    user.userEmail = this.userEmail.value;
    user.userPassword = this.userPassword.value;
    user.gender = this.gender.value;
    this.registrationService.registerNewUser(user).subscribe(
      (srdUser) => (
        (this.user = srdUser),
        console.log(
          'srdUser: ' +
            user.contactPerson +
            ' ' +
            user.clientOrganization +
            ' ' +
            user.branch +
            ' ' +
            user.userEmail +
            ' ' +
            user.gender
        ),
        this.message = 'Email sent to owner for confirmation and approval. Once Approved, the user can login.',
        this.dialog = true
      ),
      (error) =>{
        (this.message = 'Error encountered when registering new user!'),
          this.dialog = true;
        console.error(
          'Error encountered when subscribing in registerNewUser(user) ' + error
        );
      }
    );
  }

  clear() {
    this.registrationForm.reset();
    this.router.navigateByUrl('/login');
  }
}
